export function authMetadata() {
    const token = localStorage.getItem('access_token');
    if (!token) {
        return {};
    }
    return { authorization: `Bearer ${token}` };
}
